import { TFunction } from 'i18next';
import { LoginRuleListItem } from '../types';
import { DataTableMeta, LimitedContent } from '@otp/ui';
import { ActionsField } from './columns/actions';
import { DisableField } from './columns/disable';

export const getTableConfig = (
  data: Array<LoginRuleListItem>,
  { t }: { t: TFunction },
) => {
  return [
    {
      name: 'name',
      label: t('login-rules.list.fields.name'),
    },
    {
      name: 'description',
      label: t('common.description'),
      options: {
        customBodyRender: (value: string) => {
          return (
            <LimitedContent maxRows={2}>
              <div dangerouslySetInnerHTML={{ __html: value }} />
            </LimitedContent>
          );
        },
      },
    },
    {
      name: 'isDisabled',
      label: t('login-rules.list.fields.toggle-rule'),
      options: {
        customBodyRender: (_: any, column: DataTableMeta) => {
          const loginRule = data[column.rowIndex];

          return <DisableField loginRule={loginRule} />;
        },
      },
    },
    {
      name: 'actions',
      label: t('common.actions'),
      options: {
        customBodyRender: (_: any, column: DataTableMeta) => {
          const loginRule = data[column.rowIndex];

          return <ActionsField loginRule={loginRule} />;
        },
      },
    },
  ];
};
